import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { singleGetBlogContentApi } from "../../apiCalls/apiCalls";
import HeaderComponent from "../header";
import GetInTouchComponent from "../getInTouch";
import FooterComponent from "../footer";

import "../../styles/blogs/style.scss";

const BlogContentComponent = ({}) => {
  const [blogData, setBlogData] = useState();
  const { id } = useParams();
  const navigate = useNavigate();

  const refs = {
    Home: useRef(null),
    Services: useRef(null),
    "Case Studies": useRef(null),
    Blog: useRef(null),
    Contact: useRef(null),
    About: useRef(null),
  };

  const handleScrollToPortion = (section) => {
    if (section === "Contact") {
      refs[section]?.current?.scrollIntoView({ behavior: "smooth" });
    } else if (section === "About") {
      navigate(`/aboutUs`);
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  const getSingleBlogsContentFunc = () => {
    singleGetBlogContentApi(id).then((data) => {
      if (data) {
        setBlogData(data.data);
      } else {
        console.log("Error fetching HTML content");
      }
    });
  };

  useEffect(() => {
    getSingleBlogsContentFunc();
  }, [id]);

  return (
    <>
      <HeaderComponent handleScrollToPortion={handleScrollToPortion} />
      {blogData && (
        <div className="blog-content-main-page-wrapper">
          <div
            className="service-back-wrapper cursor-pointer"
            onClick={() => {
              navigate(-1);
            }}
          >
            <img src="../../images/ourServices/leftArrow.svg"></img>
            <p>Back</p>
          </div>
          <img src={blogData.image} />
          <h2>{blogData.heading}</h2>
          <h4>{blogData.subHeading}</h4>
          <div dangerouslySetInnerHTML={{ __html: blogData.content }} />
        </div>
      )}
      <GetInTouchComponent ref={refs.Contact} />
      <FooterComponent
        handleScrollToPortion={handleScrollToPortion}
        ref={refs.About}
      />
    </>
  );
};

export default BlogContentComponent;
